import { render, staticRenderFns } from "./AgtThirdStep.vue?vue&type=template&id=bf706852&"
import script from "./AgtThirdStep.vue?vue&type=script&lang=js&"
export * from "./AgtThirdStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports